import React from 'react';
import PropTypes from 'prop-types';

export default function CurrencyFormat(props) {
  const { number, whole, shortK, shortM, removeSymbol, ...currencyMaskProps } = props;

  return <span {...currencyMaskProps}>{CurrencyFormatFunc(number, whole, shortK, shortM, removeSymbol)}</span>;
}

function CurrencyFormatFunc(number, whole, shortK, shortM, removeSymbol) {

  let formatter;
  if (removeSymbol) {
    formatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  else {
    formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var formattedNumber = formatter.format(number);

  if (whole) {
    formattedNumber = formattedNumber.replace('.00', '');
  }

  if (shortK) {
    formattedNumber = formattedNumber.replace(',000', 'K');
  }

  if (shortM) {
    formattedNumber = formattedNumber.replace(',000,000', 'M+');
  }

  return formattedNumber;
}

CurrencyFormat.propTypes = {
  number: PropTypes.number.isRequired,
  whole: PropTypes.bool,
  shortK: PropTypes.bool,
  shortM: PropTypes.bool,
};

export { CurrencyFormatFunc };


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/CurrencyFormat.js